<template>
    <div class="modal fade" tabindex="-1" :id="'kt_modal_' + id">
        <div class="modal-dialog">
            <form @submit.prevent="submitForm" action="">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('tag.new_tag') }}</h5>
                    <div @click="closeModal" class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                        <span class="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                    fill="currentColor"/>
                            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                    fill="currentColor"/>
                            </svg>
                      </span>
                    </div>
                </div>
                <div class="modal-body">
                    <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                         <span class="required" >{{$t('tag.tagName')}} </span>
                    </label>
                    <input type="text" required class="form-control form-control-solid required"  v-model="formData.name" />

                   
                </div>
                <div class="modal-footer">
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
              <Button btn-class="btn-sm" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
            
            </div>
            
            </div>
        </form>

        </div>
    </div>
</template>


<script setup>


import { useStore } from "vuex";
import {useI18n} from "vue-i18n";
import { ref} from "vue";
import Button from "@/components/Button"

const props = defineProps({
    id: {
        type: String,
        default: 'kt_modal_'
    },
    isEdit: { type: Boolean, default: false },

})

const formData = ref({
    id: '',
    name: '',  
})

const store = useStore()

const resetForm=ref(false)

const emit = defineEmits(['reloadDatatable', 'reloadPayment'])

const isLoading = ref(false)

const { t } = useI18n({ useScope: 'global' })

function closeModal(){
    resetForm.value=true
    if(props.hasParent){
        $("#"+props.parent).modal('toggle')
    }
    $("#kt_modal_" + props.id).modal('hide')
}

function submitForm() {
    isLoading.value = true
 
    store.dispatch('tags/createTag', formData.value)
      .then(res => {
         emit('reloadDatatable')
         formData.value = {
            id: '',
            name: '',  
         }
         isLoading.value = false
      closeModal()
      window.toastr.success(t('notification.tag_created'))
      })
      .catch(err => {
        isLoading.value = false;
      });
  
}




</script>